import { getServiceHistoryEndpoint, } from './serviceHistoryEndpoint';
export function unwrapServiceHistoryResponse(payload) {
    const serviceHistoryData = payload.getServiceHistory ?? payload.data?.getServiceHistory;
    const legacyItems = payload.data?.serviceHistory ?? payload.data?.serviceHistoryRecords;
    const items = serviceHistoryData?.items ?? payload.items ?? legacyItems;
    return {
        items: Array.isArray(items) ? items : [],
        totalCount: serviceHistoryData?.totalCount ?? payload.totalCount,
        hasNextPage: serviceHistoryData?.hasNextPage ?? payload.hasNextPage,
    };
}
export async function fetchServiceHistoryPayload(payload, options = {}) {
    const requestPayload = {
        limit: payload?.limit ?? 100,
        offset: payload?.offset ?? 0,
    };
    if (payload?.vin)
        requestPayload.vin = payload.vin;
    if (payload?.ffmCompanyId)
        requestPayload.ffmCompanyId = payload.ffmCompanyId;
    if (payload?.repairOrderId)
        requestPayload.repairOrderId = payload.repairOrderId;
    if (payload?.searchPattern)
        requestPayload.searchPattern = payload.searchPattern;
    if (payload?.sortBy)
        requestPayload.sortBy = payload.sortBy;
    if (payload?.sortDirection)
        requestPayload.sortDirection = payload.sortDirection;
    if (payload?.segmentId ?? options.segmentId)
        requestPayload.segmentId = payload?.segmentId ?? options.segmentId;
    const endpoint = getServiceHistoryEndpoint(options);
    const response = await fetch(endpoint, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(requestPayload),
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch service history: ${response.status}`);
    }
    const apiPayload = (await response.json());
    if (Array.isArray(apiPayload.errors) && apiPayload.errors.length > 0) {
        const firstError = apiPayload.errors[0]?.message || "Service history request failed";
        throw new Error(firstError);
    }
    return apiPayload;
}
